<template>
	<div class="company-name-renderer">
		<span class="company-name-renderer__label">{{ params.value }}</span>
		<md-icon class="company-name-renderer__icon" :class="{ 'company-name-renderer__icon--active': isInPreplanning }" @click.stop="togglePreplanning">calendar_add_on</md-icon>
	</div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue';
import { iframeDataBridge } from '@/iframe/iframeDataBridge';

const PREPLANNING_KEY = 'SFA_PREPLANNING';

const props = defineProps({
	params: {
		type: Object,
		required: true,
	},
});

const isInPreplanning = ref(false);
const deliveryLocationId = props.params?.data?.deliveryLocationId ?? props.params?.data?.id ?? null;

onMounted(() => {
	if (!deliveryLocationId) return;

	const storage = iframeDataBridge.getStorage();
	if (!storage) return;

	storage.get(PREPLANNING_KEY, (data) => {
		const preplanning = data || [];
		isInPreplanning.value = preplanning.indexOf(deliveryLocationId) >= 0;
	});
});

function togglePreplanning() {
	if (!deliveryLocationId) return;

	const storage = iframeDataBridge.getStorage();
	if (!storage) return;

	storage.get(PREPLANNING_KEY, (data) => {
		let preplanning = data || [];

		if (isInPreplanning.value) {
			preplanning = preplanning.filter((id) => id !== deliveryLocationId);
		} else {
			preplanning.push(deliveryLocationId);
		}

		storage.save(PREPLANNING_KEY, preplanning);
		isInPreplanning.value = !isInPreplanning.value;

		nextTick(() => {
			props.params.api?.refreshCells({ force: true, columns: [props.params.column.getColId()] });
		});
	});
}
</script>

<style lang="scss">
.company-name-renderer {
	display: flex;
	align-items: center;
	height: 100%;

	&__label {
		flex: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	&__icon {
		font-size: 18px;
		transition: color 0.15s;
		cursor: pointer;
		color: rgba(var(--v-theme-on-surface), 0.3);
		flex-shrink: 0;

		&--active {
			color: rgb(var(--v-theme-primary));

			&:hover {
				color: rgb(var(--v-theme-error), 0.8) !important;
			}
		}

		&:hover {
			color: rgb(var(--v-theme-primary));
		}
	}
}
</style>
